/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ReasoningStepKindToolCall = zod.enum(['tool_call']);

export type ReasoningStepKindToolCall = zod.input<typeof ReasoningStepKindToolCall>;
export type ReasoningStepKindToolCallOutput = zod.output<typeof ReasoningStepKindToolCall>;
